export default "__VITE_ASSET__509f35d5__"